<script>
  import { onMount } from "svelte";
  import { _ } from "../i18n.js";
  import config from "../config.json";

  //timezone date library
  import moment from "moment-timezone";

  //Chart data store
  //import dataForChart from './chart-store'

  import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    CardFooter,
    CardSubtitle,
    Spinner,
    Alert,
  } from "sveltestrap";

  import CustomButtonToolbar from "../Layout/CustomButtonToolbar.svelte";
  import CustomDropdown from "../Layout/CustomDropdown.svelte";
  import ChartItem from "./ChartItem.svelte";

  export let idTag = "";

  let fetched;
  let name;
  let lastMeasure = "";
  let isLoading = false;
  let measurementLabels = null;
  let dataForChart = null;
  let currentChart = "";
  let errorMessage;
  let width;
  let online = true;

  $: if (fetched && currentChart !== "") {
    prepareChartData(fetched);
    online = fetched.currentmeasurement;
  }

  const url_base =
    config.urlBase +
    idTag +
    "/measurements";

  const url = "centralina/" + idTag + "/measurements";

  const getMeasurements = async () => {
    await fetch(url_base)
      .then((res) => {
        if (!res.ok) {
          throw new Error("error in API: " + res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        fetched = data;
      })
      .catch((err) => {
        errorMessage = err;
      });
  };

  const prepareLabels = (labels, intl) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return labels.map((label) =>
      new Intl.DateTimeFormat(intl, options).format(moment.utc(label).local())
    );
  };

  const prepareChartData = async (data) => {
    //console.log(data.measurements[currentChart]);
    //console.log(currentChart);
    ///console.log(data);
    dataForChart = null;
    if (data.measurements[currentChart] !== undefined) {
      dataForChart = {
        labels: prepareLabels(
          [...data.measurements.timestamps].reverse(),
          "it-IT"
        ),
        datasets: [
          {
            fill: true,
            lineTension: 0.3,
            data: [...data.measurements[currentChart][0].data].reverse(),
            label:
              $_(currentChart) +
              " - (" +
              data.measurements[currentChart][0].unit +
              ")",
            borderColor: "rgb(35,167,114)",
            backgroundColor: "rgba(35,167,114,0.3)",
          },
        ],
      };
    } else {
      //console.log(data.measurements[currentChart])
      errorMessage = $_("noData");
    }
  };

  const prepareLastTime = (time) => {
    //console.log(time);
    //console.log(moment.utc(time).local().format());
    return new Intl.DateTimeFormat("it-IT", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(moment.utc(time).local());
  };

  const onSelectChart = (event) => {
    //console.log(id);
    currentChart = event.target.id;
  };

  onMount(async () => {
    moment.locale("it");
    isLoading = true;
    const interval = setInterval(getMeasurements, config.updateTime);
    await getMeasurements();
    if (fetched) {
      //console.log(fetched);
      measurementLabels = Object.keys(fetched.currentmeasurement).filter(
        (item) => item !== "timestamp" && item !== "magnetometer" && item !=="CH2O"
      );
      currentChart = measurementLabels[0];
      name = fetched && fetched.centralina_details.name || "";
      // console.log(measurementLabels);
      await prepareChartData(fetched);
      if (fetched.currentmeasurement.timestamp) {
        lastMeasure = prepareLastTime(fetched.currentmeasurement.timestamp);
      } else {
        lastMeasure = $_("noData");
      }
      
    }
    isLoading = false;
    return () => clearInterval(interval);
  });
</script>

<div bind:clientWidth={width}>
  <Card body color="light" class="p-0 mx-auto">
    <CardHeader>
      {#if isLoading}
        Loading...
      {:else}
        <CardTitle class="d-flex" color="info"
          >{name}
          {#if online}
            <span class="ms-auto text-success"><b>Online</b></span>
          {:else}
            <span class="ms-auto text-danger"><b>Offline</b></span>
          {/if}
        </CardTitle>
        {#if !errorMessage && fetched}
        <CardSubtitle>
          {#if fetched.currentmeasurement[currentChart]}
          <b
            >{
            $_(currentChart) +
              ": " +
              fetched.currentmeasurement[currentChart].data +
              " " +
              fetched.currentmeasurement[currentChart].unit}</b
          >
          {:else}
          <b>
            {$_(currentChart)+": "  + $_("noData")}
          </b>
          {/if}
        </CardSubtitle>
        {/if}
      {/if}
    </CardHeader>
    <CardBody class="p-0">
      {#if isLoading}
        <div id={"spinner"}>
          <Spinner class="m-3 bigSpinner" color={"primary"} />
        </div>
      
      {:else}
        {#if measurementLabels}
          {#if width > 640}
            <CustomButtonToolbar
              buttonLabels={measurementLabels}
              current={currentChart}
              selectChart={onSelectChart}
            />
          {:else}
            <CustomDropdown
              menuItems={measurementLabels}
              current={currentChart}
              selectChart={onSelectChart}
            />
          {/if}
        {/if}
        {#if dataForChart}
          <ChartItem chartData={dataForChart} />
        
        {:else if errorMessage}
        <Alert color={"danger"}>{errorMessage}</Alert>
        {/if}
      {/if}
    </CardBody>
    <CardFooter inverse color="secondary">
      <CardSubtitle>
        {#if isLoading}
          <Spinner color="secondary" size="sm" />
        {:else if fetched}
          {$_("lastMeasure")}: <b>{lastMeasure}</b>
        {:else if errorMessage}
          <span class="text-danger">{errorMessage}</span>
        {/if}
      </CardSubtitle>
    </CardFooter>
  </Card>
</div>

<style>
  :global(.customColor) {
    color: rgb(35, 167, 114);
    border-color: rgb(35, 167, 114);
    background-color: rgba(35, 167, 114, 0.3);
    margin: 0.25rem;
  }

  :global(.bigSpinner) {
    width: 3.5rem;
    height: 3.5rem;
    border-width: 0.5rem;
  }

  #spinner {
    display: flex;
    justify-content: center;
  }
</style>
